import {
    Box,
    InputAdornment,
    TextField,
    TextFieldProps,
    Tooltip,
    Typography
} from "@mui/material";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import WarningIcon from "@mui/icons-material/Warning";

export type colorStatus = "success" | "warning" | "error" | "default";

export type HighlightBorderTextFieldProps = TextFieldProps & {
    colorStatus?: colorStatus;
    isAuto?: boolean;
    isInvalid?: boolean;
    invalidMessage?: string;
    autoMessage?: string;
};

const HighlightBorderTextField = (props: HighlightBorderTextFieldProps) => {
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        colorStatus,
        isAuto = false,
        autoMessage = "",
        isInvalid = false,
        invalidMessage = "",
        ...textFieldProps
    } = props;

    const adornment = () => {
        if (isInvalid) {
            return (
                <InputAdornment position="end">
                    <Tooltip
                        title={
                            <Box>
                                <Typography fontSize={12}>
                                    Invalid ICD by constraint
                                </Typography>
                                <Typography fontSize={12}>
                                    {invalidMessage}
                                </Typography>
                            </Box>
                        }
                    >
                        <WarningIcon color="warning" />
                    </Tooltip>
                </InputAdornment>
            );
        }

        if (isAuto) {
            return (
                <InputAdornment position="end">
                    <Tooltip
                        title={
                            <Box>
                                <Typography fontSize={12}>
                                    Auto by SATI
                                </Typography>
                                <Typography fontSize={12}>
                                    {autoMessage}
                                </Typography>
                            </Box>
                        }
                    >
                        <MotionPhotosAutoIcon color="primary" />
                    </Tooltip>
                </InputAdornment>
            );
        }

        return null;
    };

    const field = (
        <TextField
            {...textFieldProps}
            InputProps={{
                ...textFieldProps.InputProps,
                endAdornment: adornment()
            }}
            value={textFieldProps.value ?? ""}
        />
    );

    return field;
};

export default HighlightBorderTextField;
